import { render, staticRenderFns } from "./locale-selector-component.vue?vue&type=template&id=3d0f26e9&scoped=true&"
import script from "./locale-selector-component.vue?vue&type=script&lang=ts&"
export * from "./locale-selector-component.vue?vue&type=script&lang=ts&"
import style0 from "./locale-selector-component.vue?vue&type=style&index=0&id=3d0f26e9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d0f26e9",
  null
  
)

export default component.exports